export default __webpack_public_path__ + "static/media/11-67.3965d89e.png";